<template>
  <div>
    <el-dialog
      :title="`課堂編號:${lessonNumber} - 課程名稱:${courseTitle} - 留言紀錄 :`"
      :visible.sync="dialogCommentVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <div class="createPost-container">
        <div class="createPost-main-container">
          <section class="chatbox">
            <section v-for="(item, index) in lists" :key="index" class="chat-window">
              <article :class="(item.role===2)? 'msg-remote msg-container' : 'msg-self msg-container'">
                <div class="msg-box">
                  <span class="user-img">{{ item.user.name }}</span>
                  <div class="flr">
                    <div class="messages">
                      <p class="msg">
                        {{ item.content }}
                      </p>
                    </div>
                    <span class="timestamp"><span class="posttime">{{ item.created_at }}</span></span>
                  </div>
                </div>
              </article>
            </section>
          </section>
          <el-form ref="postForm" :model="postForm" :rules="rules" label-width="150px" class="demo-ruleForm">
            <div class="createPost-main-container">
              <el-row>
                <el-col :sm="20" :xs="16">
                  <el-input v-model="postForm.message" type="textarea" :rows="3" placeholder="請輸入內容" />
                </el-col>
                <el-col :sm="4" :xs="8">
                  <el-button type="primary" class="btn-submit" @click="onCreateComment($event)">送出</el-button>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const defaultForm = {
  message: '',
  lessonId: 0
}
export default {
  name: 'CommentDialog',
  props: {
    dialogCommentVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      postForm: Object.assign({}, defaultForm),
      lists: null,
      lessonNumber: '',
      courseTitle: '',
      rules: {}
    }
  },
  methods: {
    open() {
      this.postForm.lessonId = this.$parent.currentCommentListLessonId
      this.lessonNumber = this.$parent.currentCommentListLessonNumber
      this.courseTitle = this.$parent.currentCommentListCourseTitle
      this.lists = this.$parent.commentLists
    },
    async onCreateComment() {
      console.log(this.postForm)
      await this.$parent.createComment(this.postForm)
      this.postForm.message = ''
      this.lists = this.$parent.commentLists
    },
    handleClose(done) {
      this.lessonNumber = ''
      this.courseTitle = ''
      this.lists = null
      this.postForm.lessonId = 0
      this.postForm.message = ''
      this.$parent.dialogCommentVisible = false
    }
  }
}
</script>
<style scoped>
.el-table__body-wrapper {
  overflow: auto;
}
.el-table {
  position: inherit!important;
}
.chatbox {
    width: 100%;
    height: 50vh;
    margin-bottom: 10px;
    padding-top: 10px;
    background-color: #e6e6e6;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    box-shadow: 0 0 4px rgba(0,0,0,.14),0 4px 8px rgba(0,0,0,.28);
}
.chat-window {
    flex: auto;
    max-height: calc(100% - 60px);
    background: #e6e6e6;
    overflow: visible;
    padding-left: 5px;
    padding-right: 5px;
}
.msg-container {
    position: relative;
    display: inline-block;
    width: 100%;
    /* margin: 0 0 10px 0; */
    padding: 0;
}
.msg-box {
    display: flex;
    background: #939ed0;
    padding: 10px 10px 0 10px;
    border-radius: 6px 6px 6px 6px;
    max-width: 80%;
    width: auto;
    float: left;
    box-shadow: 0 0 2px rgba(0,0,0,.12),0 2px 4px rgba(0,0,0,.24);
}
.user-img {
    display: inline-block;
    border-radius: 50%;
    height: 40px;
    width: 90px;
    color: black;
}
.flr {
    /* flex: 1 0 auto; */
    display: flex;
    flex-direction: column;
    /* width: calc(100% - 50px); */
}
.messages {
    flex: 1 0 auto;
}
.msg {
    display: inline-block;
    font-size: 11pt;
    line-height: 13pt;
    color: rgba(255,255,255,.7);
    margin: 0 0 4px 0;
}
.msg:first-of-type {
    margin-top: 8px;
}
.timestamp {
    color: rgba(0,0,0,.38);
    font-size: 8pt;
    margin-bottom: 10px;
}
.username {
    margin-right: 3px;
}
.posttime {
    margin-left: 3px;
}
.msg-self .msg-box {
    border-radius: 15px;
    background: #4aa591;
    float: right;
}
.msg-self .msg {
    text-align: right;
}
.msg-self .timestamp {
    text-align: right;
}

.createPost-main-container el-input {
  height: 10vh;
}
.createPost-main-container .btn-submit {
  margin: 5px;
  width: 100%;
  height: 10vh;
}
</style>
